import React, { Fragment, useState } from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import PeractoRoute from '../PeractoRoute'
import Login from '../Login'
import LoginForm from '../Login/LoginForm'
import { useAuth } from '@peracto/peracto-auth'
import ForgottenForm from '../Login/ForgottenForm'
import SetPasswordForm from '../Login/SetPasswordForm'
import { LoadingIcon } from '@peracto/peracto-ui'

const PeractoInner = props => {
    const [loggingIn, setIsLoggingIn] = useState(false)
    const { loading, user, login } = useAuth()

    const [error, setError] = useState()

    const onSubmit = (inputs, headers) => {
        setIsLoggingIn(true)
        setError(false)
        login(inputs, undefined, headers)
            .catch(e => {
                setError(e.message)
            })
            .finally(() => {
                setIsLoggingIn(false)
            })
    }

    if (loading) {
        return (
            <div style={{ height: '100vh' }}>
                <div className="!flex !grow !items-center !flex-col !justify-center !h-full">
                    <LoadingIcon />
                </div>
            </div>
        )
    }

    return (
        <Fragment>
            <BrowserRouter basename="/">
                <Switch>
                    <Route
                        path="/login"
                        render={props => {
                            let { from } = props.location.state || { from: { pathname: '/' } }

                            return user.authenticated ? (
                                <Redirect to={from} />
                            ) : (
                                <Login {...props}>
                                    <LoginForm
                                        loggingIn={loggingIn}
                                        error={error}
                                        onSubmit={onSubmit}
                                    />
                                </Login>
                            )
                        }}
                    />
                    <Route
                        path="/forgotten-password"
                        render={props => (
                            <Login {...props}>
                                <ForgottenForm {...props} />
                            </Login>
                        )}
                    />
                    <Route
                        path="/set-password"
                        render={props => (
                            <Login {...props}>
                                <SetPasswordForm {...props} />
                            </Login>
                        )}
                    />
                    <Route
                        path="/"
                        render={routeProps => <PeractoRoute {...props} {...routeProps} />}
                    />
                </Switch>
            </BrowserRouter>
        </Fragment>
    )
}

export default PeractoInner
